<template>
  <sidebar-layout :sidebarItems="sidebarItems">
    <template v-slot:mainContent>
      <div>
        <router-view></router-view>
      </div>
    </template>
  </sidebar-layout>
</template>

<script>
import SidebarLayout from "@/modules/commonModule/layouts/SidebarLayout";
export default {
  name: "ShippersMainView",
  components: { SidebarLayout },
  data() {
    return {
      sidebarItems: [
        {
          text: "Dashboard",
          link: "/shipper/dashboard",
          icon: "view-dashboard"
        },
        {
          text: "New Application",
          link: "/shipper/apply",
          icon: "note-plus"
        },
        {
          text: "Saved Applications",
          link: "/shipper/saved-applications",
          icon: "view-list"
        },
        {
          text: "Approved Applications",
          link: "/shipper/approved-applications",
          icon: "certificate"
        },
        {
          text: "Application History",
          link: "/shipper/application-status",
          icon: "history"
        },

        {
          text: "Profile Settings",
          link: "/shipper/profile-settings",
          icon: "settings"
        }
      ]
    };
  }
};
</script>
